/**
 * Detect the current active responsive breakpoint in Bootstrap
 * @returns {string}
 * @author farside {@link https://stackoverflow.com/users/4354249/farside}
 */

var envs = {
  xs: 'd-none',
  sm: 'd-sm-none',
  md: 'd-md-none',
  lg: 'd-lg-none',
  xl: 'd-xl-none',
};
var keys = Object.keys(envs);

function isHidden(elem) {
  return !(
    elem.offsetWidth ||
    elem.offsetHeight ||
    elem.getClientRects().length
  );
}

function getResponsiveBreakpoint() {
  var env = '';

  var div = document.createElement('div');
  document.body.appendChild(div);

  for (var i = keys.length - 1; i >= 0; i--) {
    env = keys[i];
    div.classList.add(envs[env]);
    if (isHidden(div)) {
      break; // env detected
    }
  }
  document.body.removeChild(div);
  return env;
}
export { getResponsiveBreakpoint };
